"use strict";

/* eslint-disable func-names */
module.exports = /*@ngInject*/function ($uibModal) {
  var service = {
    isOpen: false,
    /*
      Options
        - disableRecipients: Boolean
               true -> read only display
            ** false-> (default)
        - addRecipients: Boolean
            ** true  -> will allowed to add peoples
               false -> allowed to delete and pick from given set
        - allowEmail: Boolean
            ** true  -> allowed to add emails (only when addRecipients is true)
               false -> not allowed to add emails
        - addRecipientMessage: String -> custom error message
     */
    getMessage: function getMessage(mainObject, _notification, campusCode, options, onSubmit, onCancel) {
      if (service.isOpen) return true;
      $uibModal.open({
        templateUrl: 'shared/components/email/_email-form.html',
        controllerAs: '$ctrl',
        size: 'lg',
        windowTopClass: 'email-model',
        backdrop: 'static',
        resolve: {
          notification: function notification() {
            return (
              // eslint-disable-next-line no-undef
              angular.copy(_notification || {
                toRecipients: [],
                ccRecipients: [],
                subject: null,
                bodyHtml: null
              })
            );
          }
        },
        // eslint-disable-next-line object-shorthand, no-shadow
        controller: /*@ngInject*/function controller($uibModalInstance, $q, $filter, notification) {
          var $ctrl = this;
          service.isOpen = true;
          $ctrl.campusCode = campusCode;
          // eslint-disable-next-line prefer-object-spread
          $ctrl.options = Object.assign({}, {
            disableRecipients: false,
            addRecipients: true,
            addRecipientMessage: null
          }, options);
          if ($ctrl.options.addRecipients) {
            $ctrl.options.allowEmail = $ctrl.options.allowEmail !== false;
          } else {
            $ctrl.options.allowEmail = false;
          }
          $ctrl.notification = notification;
          $ctrl.toRecipients = $ctrl.options.addRecipients ? null : Object.assign([], notification.toRecipients);
          $ctrl.ccRecipients = $ctrl.options.addRecipients ? null : Object.assign([], notification.ccRecipients);
          $ctrl.submit = function () {
            onSubmit(mainObject, $ctrl.notification);
            $ctrl.closeModal();
          };
          $ctrl.cancel = function () {
            if (onCancel) {
              onCancel();
            }
            $ctrl.closeModal();
          };
          $ctrl.closeModal = function () {
            service.isOpen = false;
            $uibModalInstance.dismiss('cancel');
          };
        }
      });
    }
  };
  return service;
};